import React, { useCallback, useEffect, useReducer, useState } from "react";
import {
  CustomAutocomplete,
  CustomButton,
  CustomCard,
  CustomDialog,
  CustomInput,
  DropzoneComponent,
} from "../../../../../../../../Components";
import { useSelectedTheme, useTranslate } from "../../../../../../../../Hooks";
import {
  GetLookupItemsByLookupTypeName,
  UpdatePropertyVideo,
} from "../../../../../../../../Services";
import { PropertyVideoCategory } from "../../../../../../../../assets/json/StaticLookupsNames.json";
import { Box, Divider, Typography } from "@material-ui/core";
import {
  getIsValidDataURL,
  getIsValidURL,
} from "../../../../../../../../Helper";
import { useVerticalNav } from "../../../../../../../../Contexts/VerticalNavContext";
import { GetFileTypeIcon } from "../../../../../../NewContactsView/ContactOverview/UI";

// styles
import useStyle from "./styles";

// Icons
import { DeleteIcon, PlusIcon } from "../../../../../../../../assets/icons";

function AddNewPropertyVideoDialog({
  onOpen,
  onClose,
  propretyId,
  setRefetchDataPropertyVideo,
}) {
  const styles = useStyle();
  const {
    theme: { palette },
  } = useSelectedTheme();
  const { translate } = useTranslate("NewPropertiesView");
  const { setAlertBoxContent } = useVerticalNav();
  function reducer(state, action) {
    return { ...state, [action.id]: action.value };
  }
  const [titleData, setTitleData] = useState([]);
  const [links, setLinks] = useState([]);
  const [uploadedFiles, setUploadedFiles] = useState([]);
  const [filesAccepted, setFilesAccepted] = useState([]);
  const [uploadedFileId, setUploadedFileId] = useState(null);
  const [state, setState] = useState({
    propertyId: Number(propretyId) || null,
  });
  const [selected, setSelected] = useReducer(reducer, {
    lookupItemName: "",
    lookupItemId: "",
    files: [
      {
        fileId: null,
        fileName: null,
        documentLink: null,
      },
    ],
  });

  const getAllTitle = useCallback(async () => {
    const res = await GetLookupItemsByLookupTypeName({
      lookUpName: PropertyVideoCategory,
      pageSize: 100,
      pageIndex: 1,
    });
    if (!(res && res.status && res.status !== 200))
      setTitleData(res.result || []);
    else setTitleData([]);
  }, []);

  const handleAddMoreLinks = () => {
    const linkToValidate = selected?.files[0]?.documentLink;
    const isLinkExistBefore =
      links.findIndex((link) => link === linkToValidate) !== -1;
    const isValidUrl =
      getIsValidURL(linkToValidate) || getIsValidDataURL(linkToValidate);

    if (isValidUrl && !isLinkExistBefore) {
      setLinks((prevLinks) => [...prevLinks, linkToValidate]);
      setSelected({
        id: "files",
        value: [
          {
            fileId: null,
            fileName: null,
            documentLink: "",
          },
        ],
      });
    } else {
      setAlertBoxContent({
        display: true,
        variant: "error",
        title: translate("Enter-Valid-url"),
        onClose: () => {
          setAlertBoxContent(null);
        },
      });

      setSelected({
        id: "files",
        value: [
          {
            fileId: null,
            fileName: null,
            documentLink: "",
          },
        ],
      });
      return;
    }
  };

  const handleDeleteLink = (index) => {
    setLinks((prevLinks) => prevLinks.filter((_, i) => i !== index));
  };

  const handleDeleteUploadedFile = (index) => {
    setUploadedFiles((prevUploadedFiles) =>
      prevUploadedFiles.filter((_, i) => i !== index)
    );
  };

  const handleFilesAccepted = (files) => {
    setFilesAccepted(files);
  };

  const handleUrlChange = (e) => {
    setSelected({
      id: "files",
      value: [
        {
          ...selected.files[0],
          documentLink: e.target.value,
        },
      ],
    });
  };

  const formatUploadedDocumentToMapp = () => {
    if (uploadedFileId) {
      setUploadedFiles((prevUploadedFiles) => [
        ...prevUploadedFiles,
        filesAccepted[0],
      ]);
      setUploadedFiles((prevUploadedFiles) => {
        const updatedFiles = [...prevUploadedFiles];
        if (updatedFiles?.length > 0) {
          updatedFiles[updatedFiles.length - 1] = {
            ...updatedFiles[updatedFiles.length - 1],
            fileId: uploadedFileId,
            fileSize: updatedFiles[updatedFiles?.length - 1]?.size,
            fileName: updatedFiles[updatedFiles?.length - 1]?.path,
            fileType: updatedFiles[updatedFiles?.length - 1]?.type,
          };
        }
        return updatedFiles;
      });
    }
  };

  const addPropertyVideo = useCallback(async () => {
    try {
      const mappedFiles = uploadedFiles.map((file) => ({
        fileId: file?.uuid || file?.fileId || "",
        fileName: file?.fileName || file?.path || "",
        videoLink: "",
      }));

      const mappedLinks = links.map((link) => ({
        fileId: null,
        fileName: null,
        videoLink: link,
      }));

      const body = {
        ...state,
        files: [...mappedFiles, ...mappedLinks],
      };
      const res = await UpdatePropertyVideo(body);
      if (!(res && res.status && res.status !== 200)) {
        setAlertBoxContent({
          display: true,
          variant: "success",
          title: translate("create-Video-Property-successfully"),
          onClose: () => {
            setAlertBoxContent(null);
          },
        });
        setRefetchDataPropertyVideo(true);
        onClose();
      } else {
        const errorMessage = res?.data?.Message || res?.message;
        if (
          errorMessage.includes(
            "PROPERTY_IMAGE_ALREADY_EXISTS_PLEASE_UPDATE_THIS_PROPERTY_IMAGE"
          )
        ) {
          setAlertBoxContent({
            display: true,
            variant: "error",
            title: translate(
              "PROPERTY_IMAGE_ALREADY_EXISTS_PLEASE_UPDATE_THIS_PROPERTY_IMAGE_OR_SELECT_ANOTHER_PROPERTY"
            ),
            onClose: () => {
              setAlertBoxContent(null);
            },
          });
        } else {
          setAlertBoxContent({
            display: true,
            variant: "error",
            title: translate("Something-went-wrong"),
            onClose: () => {
              setAlertBoxContent(null);
            },
          });
        }
      }
    } catch (error) {
      console.error(error, "Something went wrong");
    } finally {
    }
  }, [state, uploadedFiles]);

  useEffect(() => {
    if (propretyId !== null) getAllTitle();
  }, []);

  useEffect(() => {
    formatUploadedDocumentToMapp();
  }, [uploadedFileId]);

  return (
    <CustomDialog
      open={onOpen}
      onClose={() => {
        onClose();
      }}
      title={translate("Add-new-property-videos")}
      subtitle={translate(
        "Create-and-schedule-new-activity-to-enhance-engagement-with-your-contacts-and-leads"
      )}
      cancelText={translate("Cancel")}
      confirmText={translate("add")}
      onConfirm={() => {
        addPropertyVideo();
      }}
      contentDialogClass={styles.containerContentDialog}
      width={"688px"}
      isDisabled={
        (links.length === 0 && uploadedFiles.length === 0) || !state.categoryId
      }
      content={
        <Box className={styles.wrapperDialog}>
          <Box className={styles.containerFiledItem}>
            <Box className={styles.containerTitles}>
              <Typography className={styles.titleItem}>
                {translate("Title")}
              </Typography>
              <Typography className={styles.subTitleItem}>
                {translate("Where-to-add-image")}
              </Typography>
            </Box>
            <CustomAutocomplete
              placeholder={translate("Select")}
              options={titleData}
              value={selected?.lookupItemName || null}
              onChange={(e, value) => {
                setSelected({
                  id: "lookupItemName",
                  value: value,
                });
                setState((prev) => ({
                  ...prev,
                  categoryId: value?.lookupItemId || null,
                }));
              }}
              getOptionLabel={(option) => option?.lookupItemName || ""}
              getOptionValue={(option) => option?.lookupItemName || ""}
              renderOption={(option) => option?.lookupItemName || ""}
            />
          </Box>
          <Divider />
          <Box className={styles.containerFiledItem}>
            <Typography className={styles.titleItem}>
              {translate("Link")}
            </Typography>
            <Box className={styles.containerLinkInput}>
              <CustomInput
                placeholder={translate("Enter")}
                hasSearchIcon={false}
                style={{ maxWidth: "100%" }}
                value={selected?.files[0]?.documentLink || null}
                type="text"
                onChange={(e) => {
                  handleUrlChange(e);
                }}
              />
              <Box>
                <CustomButton
                  size="sm"
                  variant="text"
                  color="tertiaryGray"
                  startIcon={
                    <PlusIcon
                      width="20"
                      height="20"
                      fill={palette.button.tertiaryGray_fg}
                    />
                  }
                  onClick={() => {
                    handleAddMoreLinks();
                  }}
                  disabled={
                    !selected?.files?.length ||
                    !selected?.files[0]?.documentLink?.trim() ||
                    links?.length < 0
                  }
                >
                  {translate("Add-another")}
                </CustomButton>
              </Box>
            </Box>
          </Box>
          <Box>
            {" "}
            {links?.length > 0 && (
              <CustomCard
                boxShadow="xs"
                borderRadius="xl"
                borderColor="secondary"
                classes={styles.MoreLinkesContainer}
              >
                <Box className={styles.HeaderTableSection}>
                  <Typography className={styles.TitleItemTable}>
                    {translate("Link")}
                  </Typography>
                  <Typography className={styles.TitleItemTable}>
                    {translate("Action")}
                  </Typography>
                </Box>
                <Divider />
                <Box className={styles.BodyTableSection}>
                  {links.map((link, index) => (
                    <Box key={index} className={styles.rowMoreLinkes}>
                      <Box className={styles.containerLink_Name}>
                        <Typography className={styles.LinkName}>
                          <a
                            href={link}
                            target="_blank"
                            rel="noopener noreferrer"
                            className={styles.HyperLinkItem}
                          >
                            {link}
                          </a>
                        </Typography>
                      </Box>
                      <Box className={styles.containerDelete_Icon}>
                        <DeleteIcon
                          width="20"
                          height="20"
                          fill={palette.button.tertiaryGray_fg}
                          style={{ cursor: "pointer" }}
                          onClick={() => handleDeleteLink(index)}
                        />
                      </Box>
                    </Box>
                  ))}
                </Box>
              </CustomCard>
            )}
          </Box>
          <Divider />
          <Box className={styles.containerFiledItem}>
            <Typography className={styles.titleItem}>
              {translate("Videos")}
            </Typography>
            <Box className={styles.uploadedSection}>
              <DropzoneComponent
                accept="video/*"
                title={translate("SVG-PNG-JPG-or-GIF-max-800x400px")}
                onFilesAccepted={handleFilesAccepted}
                setUploadedFileId={setUploadedFileId}
              />
              {uploadedFiles && uploadedFiles?.length > 0 && (
                <Box className={styles.containerUpladedFilesCrads}>
                  {uploadedFiles
                    .filter((file) => file?.fileType)
                    .map((uploadFile, index) => (
                      <CustomCard
                        boxShadow="xs"
                        borderRadius="xl"
                        borderColor="secondary"
                        classes={styles.CardUploadedFilesInfo}
                        key={index}
                      >
                        {GetFileTypeIcon(uploadFile?.fileType)}
                        <Box className={styles.ContainerFileUploadedInfo}>
                          <Box className={styles.containerTitleAndDeleteIcon}>
                            <Typography className={styles.TitleFileName}>
                              {uploadFile?.fileName}
                            </Typography>
                            <DeleteIcon
                              width="20"
                              height="20"
                              className={styles.DeleteIcon}
                              style={{ cursor: "pointer" }}
                              fill={palette.button.secondary_fg}
                              onClick={() => handleDeleteUploadedFile(index)}
                            />
                          </Box>
                          <Typography className={styles.FileSizeTitle}>
                            {uploadFile.fileSize
                              ? `${uploadFile?.fileSize} bytes`
                              : "Unknown Size"}
                          </Typography>
                        </Box>
                      </CustomCard>
                    ))}
                </Box>
              )}
            </Box>
          </Box>
        </Box>
      }
    ></CustomDialog>
  );
}

export default AddNewPropertyVideoDialog;
